import { Link } from "react-router-dom";
import { BedDouble, Bath, MapPin, ArrowRight, DoorOpen } from "lucide-react";
import StatusBadge from "@/components/StatusBadge";

export default function PropertyCard({ property: p }) {
  const hasRooms = p.rooms?.length > 0;
  return (
    <article
      data-testid={`property-card-${p.id}`}
      className="group rounded-2xl overflow-hidden border border-[#E4DBD0] dark:border-[#352F2B] bg-white dark:bg-[#1A1715] transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-[#A05A32]/10"
    >
      <div className="relative aspect-[16/10] overflow-hidden">
        {p.image ? (
          <img
            src={p.image}
            alt={p.title}
            loading="lazy"
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        ) : (
          <div className="h-full w-full bg-[#ECE5DD] dark:bg-[#231F1C] flex items-center justify-center">
            <MapPin className="h-8 w-8 text-[#C7BEB5]" />
          </div>
        )}
        <div className="absolute top-3 left-3">
          <StatusBadge status={p.status} testId={`property-card-status-${p.id}`} />
        </div>
        {hasRooms && (
          <div className="absolute bottom-3 right-3 rounded-full bg-[#1A1715]/80 backdrop-blur px-4 py-1.5 text-sm font-semibold text-[#EFF0F2]">
            {p.rooms.filter((r) => r.status === "Available").length} of {p.rooms.length} rooms free
          </div>
        )}
      </div>
      <div className="p-5 sm:p-6">
        <p className="text-xs uppercase tracking-[0.2em] font-mono text-[#A05A32] dark:text-[#D9773F] mb-1.5">
          {p.type}
        </p>
        <h3 className="text-xl sm:text-2xl font-serif font-medium tracking-tight text-[#1A1715] dark:text-[#F7F4F0]">
          {p.title}
        </h3>
        <p className="mt-1.5 flex items-center gap-1.5 text-sm text-[#8A837C] dark:text-[#8E867E]">
          <MapPin className="h-3.5 w-3.5 shrink-0" />
          {p.location}
        </p>
        <div className="mt-4 flex items-center gap-4 text-sm text-[#57524E] dark:text-[#C7BEB5]">
          {hasRooms ? (
            <span className="inline-flex items-center gap-1.5">
              <DoorOpen className="h-4 w-4" /> {p.rooms.length} Rooms
            </span>
          ) : (
            <span className="inline-flex items-center gap-1.5">
              <BedDouble className="h-4 w-4" /> {p.bedrooms} Bed
            </span>
          )}
          <span className="inline-flex items-center gap-1.5">
            <Bath className="h-4 w-4" /> {p.bathrooms} Bath
          </span>
        </div>
        <Link
          to={`/property/${p.id}`}
          data-testid={`property-card-view-btn-${p.id}`}
          className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-[#A05A32] dark:text-[#D9773F] hover:gap-3 transition-all"
        >
          {hasRooms ? "View Rooms" : "View Residence"} <ArrowRight className="h-4 w-4" />
        </Link>
      </div>
    </article>
  );
}
